export const GOOGLE_API_KEY = 'AIzaSyB2gTkcTlIn1gLwo6GYtomhmHC2RxZl-OE';
export const SCHEDULE_ID = 'r4ku9v6ohn3degft8rgqbpp4n7ajdmr6@import.calendar.google.com';
export const EVENTS_ID = 'fabnolalab@gmail.com';
export const CLOSED_ID = '675ijb450qqkqpe39e019icbvc@group.calendar.google.com';